import { modalTypes } from './actions';

const initialState = {
  modalData: {
    type: '',
    props: {}
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case modalTypes.OPEN_MODAL.SUCCESS:
      return {
        ...state,
        modalData: action.payload
      };
    case modalTypes.CLOSE_MODAL.SUCCESS:
      return {
        ...state,
        modalData: initialState.modalData
      };
    default:
      return { ...state };
  }
};
